<template>
  <div
    class="p-4 md:p-6 lg:p-8 xl:p-10 bg-app-bg-light dark:bg-app-bg-dark min-h-screen"
  >
    <div class="mb-8">
      <h1 class="text-3xl font-bold text-slate-800 dark:text-slate-100 mb-2">
        Panel de Supervisión
      </h1>
      <p class="text-slate-600 dark:text-slate-400">
        Control de calidad - {{ fechaActual }}
      </p>
    </div>

    <!-- Filtro de Fecha -->
    <div
      class="bg-white dark:bg-slate-800 rounded-xl p-4 md:p-5 shadow-sm mb-8"
    >
      <h2
        class="text-base font-semibold text-slate-700 dark:text-slate-200 mb-3 flex items-center gap-2"
      >
        <i class="bx bx-filter-alt text-custom-primary"></i> Filtro de Fecha
      </h2>
      <div class="flex flex-wrap gap-4 items-end">
        <div>
          <label class="text-xs text-slate-500 dark:text-slate-400 mb-1 block"
            >Fecha inicio</label
          >
          <input
            type="date"
            v-model="filtro.fechaInicio"
            class="border border-slate-300 dark:border-slate-600 rounded-lg px-3 py-2 text-sm bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-custom-primary"
          />
        </div>
        <div>
          <label class="text-xs text-slate-500 dark:text-slate-400 mb-1 block"
            >Hora inicio</label
          >
          <input
            type="time"
            v-model="filtro.horaInicio"
            class="border border-slate-300 dark:border-slate-600 rounded-lg px-3 py-2 text-sm bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-custom-primary"
          />
        </div>
        <div>
          <label class="text-xs text-slate-500 dark:text-slate-400 mb-1 block"
            >Fecha fin</label
          >
          <input
            type="date"
            v-model="filtro.fechaFin"
            class="border border-slate-300 dark:border-slate-600 rounded-lg px-3 py-2 text-sm bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-custom-primary"
          />
        </div>
        <div>
          <label class="text-xs text-slate-500 dark:text-slate-400 mb-1 block"
            >Hora fin</label
          >
          <input
            type="time"
            v-model="filtro.horaFin"
            class="border border-slate-300 dark:border-slate-600 rounded-lg px-3 py-2 text-sm bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-custom-primary"
          />
        </div>
        <button
          @click="cargarTodo"
          class="bg-custom-primary hover:opacity-90 text-white px-4 py-2 rounded-lg text-sm font-medium transition-opacity border-0"
        >
          <i class="bx bx-refresh mr-1"></i>Actualizar
        </button>
      </div>
    </div>

    <div class="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-sm mb-8">
      <h2 class="text-xl font-semibold text-slate-800 dark:text-slate-100 mb-6">
        Acciones Rápidas
      </h2>
      <div class="grid grid-cols-2 gap-4">
        <button
          @click="$router.push('/supervisar-limpieza')"
          class="flex flex-col items-center p-4 rounded-lg bg-white dark:bg-slate-800 hover:bg-slate-100 dark:hover:bg-slate-700 shadow-md hover:shadow-lg transition-all group border-0"
        >
          <i
            class="bx bx-search-alt text-4xl text-custom-primary mb-2 group-hover:scale-110 transition-transform"
          ></i>
          <span class="text-sm text-slate-700 dark:text-slate-300"
            >Supervisar Limpieza</span
          >
        </button>
        <button
          @click="cargarHabitacionesPendientes()"
          class="flex flex-col items-center p-4 rounded-lg bg-white dark:bg-slate-800 hover:bg-slate-100 dark:hover:bg-slate-700 shadow-md hover:shadow-lg transition-all group border-0"
        >
          <i
            class="bx bx-refresh text-4xl text-custom-primary mb-2 group-hover:scale-110 transition-transform"
          ></i>
          <span class="text-sm text-slate-700 dark:text-slate-300"
            >Actualizar</span
          >
        </button>
      </div>
    </div>
    <div class="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-8">
      <div class="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-sm">
        <div class="p-3 bg-blue-100 dark:bg-blue-900/30 rounded-lg w-fit mb-3">
          <i class="bx bx-task text-3xl text-blue-600 dark:text-blue-400"></i>
        </div>
        <h3 class="text-2xl font-bold text-slate-800 dark:text-slate-100">
          {{ stats.inspeccionesPendientes }}
        </h3>
        <p class="text-sm text-slate-600 dark:text-slate-400">
          Inspecciones Pendientes
        </p>
      </div>
      <div class="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-sm">
        <div
          class="p-3 bg-green-100 dark:bg-green-900/30 rounded-lg w-fit mb-3"
        >
          <i
            class="bx bx-check-circle text-3xl text-green-600 dark:text-green-400"
          ></i>
        </div>
        <h3 class="text-2xl font-bold text-slate-800 dark:text-slate-100">
          {{ stats.inspeccionesHoy }}
        </h3>
        <p class="text-sm text-slate-600 dark:text-slate-400">
          Inspecciones Hoy
        </p>
      </div>
      <div class="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-sm">
        <div class="p-3 bg-red-100 dark:bg-red-900/30 rounded-lg w-fit mb-3">
          <i class="bx bx-error text-3xl text-red-600 dark:text-red-400"></i>
        </div>
        <h3 class="text-2xl font-bold text-slate-800 dark:text-slate-100">
          {{ stats.observaciones }}
        </h3>
        <p class="text-sm text-slate-600 dark:text-slate-400">Observaciones</p>
      </div>
    </div>
    <div class="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-sm mb-8">
      <h2 class="text-xl font-semibold text-slate-800 dark:text-slate-100 mb-6">
        Habitaciones por Inspeccionar
      </h2>
      <div
        v-if="habInspeccion.length === 0"
        class="text-center text-slate-500 dark:text-slate-400 py-8"
      >
        No hay habitaciones pendientes de supervisión
      </div>
      <div v-else class="space-y-3">
        <div
          v-for="hab in habInspeccion"
          :key="hab.IdReservaHabitacion"
          class="flex items-center justify-between p-4 rounded-lg hover:bg-slate-50 dark:hover:bg-slate-700"
        >
          <div class="flex items-center gap-3">
            <div
              class="w-12 h-12 bg-blue-100 dark:bg-blue-900/30 rounded-lg flex items-center justify-center"
            >
              <span class="font-bold text-blue-600 dark:text-blue-400">{{
                hab.numero
              }}</span>
            </div>
            <div>
              <p class="font-medium text-slate-800 dark:text-slate-100">
                {{ hab.tipo }}
              </p>
              <p class="text-sm text-slate-500 dark:text-slate-400">
                {{ hab.estado }}
              </p>
            </div>
          </div>
          <button
            @click="inspeccionar(hab)"
            class="text-custom-primary px-4 py-2 rounded-lg transition-all hover:opacity-80 border-0 bg-transparent"
          >
            Inspeccionar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/config/config.js";

export default {
  name: "DashboardSupervisor",
  data() {
    const hoy = new Date();
    const manana = new Date(hoy);
    manana.setDate(manana.getDate() + 1);
    return {
      filtro: {
        fechaInicio: hoy.toISOString().slice(0, 10),
        horaInicio: '08:00',
        fechaFin: manana.toISOString().slice(0, 10),
        horaFin: '08:00',
      },
      stats: {
        inspeccionesPendientes: 0,
        inspeccionesHoy: 0,
        observaciones: 0,
      },
      habInspeccion: [],
    };
  },
  computed: {
    fechaActual() {
      return new Date().toLocaleDateString("es-ES", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
    datetimeInicio() {
      return `${this.filtro.fechaInicio} ${this.filtro.horaInicio}:00`;
    },
    datetimeFin() {
      return `${this.filtro.fechaFin} ${this.filtro.horaFin}:00`;
    },
  },
  async mounted() {
    await this.cargarTodo();
  },
  methods: {
    cargarTodo() {
      return Promise.all([
        this.cargarEstadisticas(),
        this.cargarHabitacionesPendientes(),
      ]);
    },
    async cargarEstadisticas() {
      try {
        const res = await axios.get(`${API_URL}/dashboard/supervisor`, {
          params: {
            fecha_inicio: this.datetimeInicio,
            fecha_fin: this.datetimeFin,
          },
        });
        this.stats = {
          inspeccionesPendientes: res.data.pendientes,
          inspeccionesHoy: res.data.completadas,
          observaciones: res.data.observaciones,
        };
      } catch (error) {
        console.error("Error al cargar estadísticas:", error);
      }
    },
    async cargarHabitacionesPendientes() {
      try {
        const res = await axios.get(
          `${API_URL}/habitaciones-pendientes-supervision`,
        );
        this.habInspeccion = res.data.map((item) => ({
          IdReservaHabitacion: item.IdReservaHabitacion,
          numero: item.reservacion?.habitacion?.Numero || "N/A",
          tipo: item.reservacion?.habitacion?.tipo?.Nombre || "Desconocido",
          estado: "Limpieza completada",
        }));
      } catch (error) {
        console.error("Error al cargar habitaciones:", error);
      }
    },
    inspeccionar() {
      this.$router.push("/supervisar-limpieza");
    },
  },
};
</script>
